import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../environments/environment';
import { BaseApiService } from './api';

@Injectable({
    providedIn: 'root'
})
export class SalesloftService {
    isIndividualAssignment : boolean = false;

    constructor(
        private readonly baseApiService: BaseApiService
    ) {

    }

    authenticate(code: string): Observable<any> {
        return this.baseApiService.post('salesloft/authenticate', {}, { params: {
            code: code,
            redirect_uri: environment.salesloft.redirectUrl
        }});
    }

    logout(): Observable<any> {
        const iframe = document.createElement('iframe');
        iframe.src = 'https://accounts.salesloft.com/sign_out';
        iframe.style.cssText = 'position:fixed;top:0;left:0;display:none;width:100px;height:100px;z-index:0;';
        document.body.appendChild(iframe);
        return this.baseApiService.get(`salesloft/logout`);
    }

    saveSettings(payload: any): Observable<any> {
        return this.baseApiService.post(`salesloft/settings`, payload);
    }

    setCadence(): Observable<any> {
        return this.baseApiService.get(`salesloft/cadences`);
    }

    getTags(): Observable<any> {
        return this.baseApiService.get(`salesloft/tags`);
    }

    refreshToken(): Observable<any> {
        return this.baseApiService.post(`salesloft/refreshToken`);
    }

    validateDuplicates(matchIds): Observable<any> {
        return this.baseApiService.post('service/contactcloud/salesloft/duplicate', {
            ids: matchIds
        });
    }

    exportV2Batch(toBeExported, duplicateResolution, selectedCadence, available_tags): Observable<any> {
        return this.baseApiService.post('service/contactcloud/salesloft/exportV2', {
            ids: toBeExported,
            duplicateResolution: duplicateResolution === 'skip' ? '' : duplicateResolution,
            cadences: selectedCadence,
            tags: available_tags
        });
    }

    exportV2(toBeExported, duplicateResolution, available_tags): Observable<any> {
        const data = {
            ids: toBeExported,
            duplicateResolution: duplicateResolution === 'skip' ? '' : duplicateResolution,
            tags: available_tags
        }
        return this.baseApiService.post(`service/contactcloud/salesloft/exportV2`, data);
    }

    getSettings(): Observable<any> {
        return this.baseApiService.get('service/contactcloud/salesloft/settings');
    }
    saveSettingsData(payload: any): Observable<any> {
        return this.baseApiService.put('service/contactcloud/salesloft/settings', payload);
    }
}
